var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-talk-bubble-wrapper",
      class: {
        "cw-talk-bubble-own-post": _vm.payload.own,
      },
    },
    [
      !_vm.payload.own
        ? _c(
            "div",
            {
              staticClass: "cw-talk-bubble-avatar",
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.payload.user_avatar,
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-talk-bubble",
        },
        [
          _c(
            "div",
            {
              staticClass: "cw-talk-bubble-content",
            },
            [
              !_vm.payload.own
                ? _c(
                    "header",
                    {
                      staticClass: "cw-talk-bubble-header",
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.userProfileUrl,
                          },
                        },
                        [_vm._v(_vm._s(_vm.payload.user_formatted_name))]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cw-talk-bubble-talktext",
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.payload.content))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cw-talk-bubble-footer",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "cw-talk-bubble-talktext-time",
                        },
                        [
                          _c("iso-date", {
                            attrs: {
                              date: _vm.payload.chdate,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.userIsTeacher || _vm.payload.own
                        ? _c(
                            "button",
                            {
                              attrs: {
                                title: _vm.$gettext("Löschen"),
                              },
                              on: {
                                click: function click($event) {
                                  _vm.showDeleteDialog = true
                                },
                              },
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "trash",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showDeleteDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Eintrag löschen"),
              question: _vm.$gettext("Möchten Sie diesen Eintrag löschen?"),
              height: "180",
              width: "360",
            },
            on: {
              confirm: _vm.deletePost,
              close: _vm.closeDeleteDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }